export enum QuillFontsEnum {
    arial = 'Arial, Helvetica, sans-serif',
    helvetica = 'Helvetica, Arial, sans-serif',
    courierNew = 'Courier New, Courier, monospace',
    georgia = 'Georgia, serif',
    lucida = 'Lucida Sans Unicode, Lucida Grande, sans-serif',
    tahoma = 'Tahoma, Geneva, sans-serif',
    times = 'Times New Roman, Times, serif',
    trebuchetMS = 'Trebuchet MS, Helvetica, sans-serif',
    verdana = 'Verdana, Geneva, sans-serif'
}
